import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;
	}

	.controls {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 5px;
		border-bottom: 1px solid var(--og-border-color, #ddd);
		flex: 0 0 auto;
	}

	.controls .label {
		color: var(--og-text-muted-color, #888);
		font-size: 12px;
	}

	og-splitcontainer {
		flex: 1 1 auto;
		min-height: 0;
	}

	og-tree-dropdown {
		min-width: 220px;
	}
`;
